/// <reference types="@types/google.maps" />

import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { CandidateMeetingModel, LocationDescriptor } from "../../../interviews.models";
import { InterviewType } from "../../../interviews.enums";

@Component({
    selector: 'interview-location-map-widget',
    templateUrl: './interview-location-map-widget.component.html',
    standalone: false
})
export class InterviewLocationMapWidgetComponent implements OnChanges {
  @Input() meeting?: CandidateMeetingModel;

  public center?: google.maps.LatLngLiteral;
  public zoom = 16;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['meeting']) {
      this.center = undefined;
      if (this.meeting && this.meeting!.interviewType == InterviewType.INPERSON && this.meeting!.location) {
        this.updateMapPosition(this.meeting!.location!);
      }
    }
  }

  updateMapPosition(location: LocationDescriptor) {
    const autocompleteService = new google.maps.places.AutocompleteService();
    autocompleteService.getPlacePredictions({input: this.formatLocationString(location)})
    .then(result => {
      if (!result.predictions.length) {
        return;
      }
      const request = {
        placeId: result.predictions[0].place_id,
        fields: ["address_components", "adr_address", "geometry", "name"],
        sessionToken: new google.maps.places.AutocompleteSessionToken() // Add session token
      };

      const map = new google.maps.Map(document.createElement('div')); // Create a dummy map
      const placesService = new google.maps.places.PlacesService(map);
      placesService.getDetails(request, (place, status) => {
        const lat = place?.geometry?.location?.lat();
        const lng = place?.geometry?.location?.lng();
        if (lat && lng) {
          this.center = {lat: lat ?? 0, lng: lng ?? 0};
        }
      })
    });
  }

  formatLocationString(location: LocationDescriptor) {
    return [location.address, location.postCode]
    .filter(n => n)
    .join(', ');
  }
}
